export { default as PropertiesPage } from './Properties'
